import { render } from "./ng.vue?vue&type=template&id=9a39aa82&scoped=true"
import script from "./ng.vue?vue&type=script&lang=js"
export * from "./ng.vue?vue&type=script&lang=js"

import "./ng.vue?vue&type=style&index=0&id=9a39aa82&lang=scss&scoped=true"

import exportComponent from "D:\\codes\\chat28\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a39aa82"]])

export default __exports__